export const apiAuthorize = `${process.env.REACT_APP_API_AUTHORIZE_BASIC}`;

export const apiUrl = `${process.env.REACT_APP_API_BASE_URL}`;

export const wpApiUrl = `${process.env.REACT_APP_WP_API_BASE_URL}`;

export const turnstileSiteKey = `${process.env.REACT_APP_TURNSTILE_SITE_KEY}`;

export const apiService = {
  auth: {
    login: `${apiUrl}/auth/oauth/token`,

    user: {
      register: `${apiUrl}/auth/user/register`,
      logout: `${apiUrl}/auth/user/logout`,
      checkOTP: `${apiUrl}/auth/user/check-otp`,
      getOTP: `${apiUrl}/auth/user/get-otp`,
      updatePassword: `${apiUrl}/auth/user/update-password`,
      getAccountSetting: `${apiUrl}/auth/user/update-profiles`,
      updateAccountSetting: `${apiUrl}/auth/user/update-profiles`,
      getUserInfo: `${apiUrl}/auth/user/get-user-info`,
      uploadAvatar: `${apiUrl}/auth/user/upload-avatar`,
    },

    site: {
      getList: `${apiUrl}/auth/site/get-list`,
      getByCode: `${apiUrl}/auth/site/get-by-code`,
      getById: `${apiUrl}/auth/site/get-by-id`,
      getBySlug: `${apiUrl}/auth/site/get-by-slug`,
    },

    state: {
      getList: `${apiUrl}/auth/state/list`,
    },
  },

  patient: {
    record: {
      create: `${apiUrl}/patient/patient-record/`,
      update: `${apiUrl}/patient/patient-record`,
      delete: `${apiUrl}/patient/patient-record/delete`,
      seDefault: `${apiUrl}/patient/patient-record/set-default`,
      getById: `${apiUrl}/patient/patient-record`,
      getByUserKey: `${apiUrl}/patient/patient-record/by-user-key`,
      getByCode: `${apiUrl}/patient/patient-record/by-code`,
      syncClinicRecord: `${apiUrl}/patient/patient-record/sync-clinic-record`,
    },

    order: {
      create: `${apiUrl}/patient/order/`,
      orderCode: `${apiUrl}/patient/order/`,
      myOrders: `${apiUrl}/patient/order/my-orders`,
      orderTransCode: `${apiUrl}/patient/order/get-by-order-trans-code`,
      orderByRefCode: `${apiUrl}/patient/order/get-by-ref-code`,
    },

    patientSpecialPackage: {
      calculateFee: `${apiUrl}/patient/patient-special-package/calculate-fee`,
      buy: `${apiUrl}/patient/patient-special-package/buy`,
      findAll: `${apiUrl}/patient/patient-special-package/find-all-by-patient-record-code`,
      myPackages: `${apiUrl}/patient/patient-special-package/my-packages`,
      getDetails: `${apiUrl}/patient/patient-special-package/get-details`,
      createDetailImplement: `${apiUrl}/patient/patient-special-package-detail-implement/create`,
      selectServiceItems: `${apiUrl}/patient/patient-special-package/select-service-items`,
      claimEVoucher: `${apiUrl}/patient/patient-special-package/claim-e-voucher`,
    },

    patientInsurance: {
      healthByPatientCode: `${apiUrl}/patient/patient-insurance/health-by-patient-code`,
      lifeByPatientCode: `${apiUrl}/patient/patient-insurance/life-by-patient-code`,
      saveLife: `${apiUrl}/patient/patient-insurance/save-life-insurance`,
      uploadLifeFiles: `${apiUrl}/patient/patient-insurance/upload-life-insurance`,
      deleteLife: `${apiUrl}/patient/patient-insurance/delete-patient-life-insurance`,
      deleteLifeFile: `${apiUrl}/patient/patient-insurance/delete-file-life-insurance`,
      lifeProviders: `${apiUrl}/patient/life-insurance/get-list`,
      saveHealth: `${apiUrl}/patient/patient-insurance/save-health-insurance`,
    },

    healthInsurance: {
      decode: `${apiUrl}/patient/health-insurance/decode`,
    },

    customerDeliveryAddress: {
      myAddresses: `${apiUrl}/patient/customer-delivery-address/my-addresses`,
      save: `${apiUrl}/patient/customer-delivery-address/`,
      delete: `${apiUrl}/patient/customer-delivery-address`,
    },

    reAppointment: {
      create: `${apiUrl}/patient/re-appointment/`,
      getMyReAppointment: `${apiUrl}/patient/re-appointment/my-re-appointment`,
      getById: `${apiUrl}/patient/re-appointment`,
    },

    insmartPolicyActivation: {
      lookup: `${apiUrl}/patient/integration/insmart/policy-activation/lookup`,
      requestOTP: `${apiUrl}/patient/integration/insmart/policy-activation/request-otp`,
      activate: `${apiUrl}/patient/integration/insmart/policy-activation/activate`,
    },

    drugOrder: {
      create: `${apiUrl}/patient/drug-order/`,
      getAllByPatientRecordCode: `${apiUrl}/patient/drug-order/get-all-by-patient-record-code`,
      uploadImage: `${apiUrl}/patient/drug-order/upload-image-drug-order`,
      getByCode: `${apiUrl}/patient/drug-order`,
    },
  },

  doctor: {
    getList: `${apiUrl}/doctor/doctor/list-doctor`,
    getByCodeLess: `${apiUrl}/doctor/doctor/get-by-code-less`,
    getBySlug: `${apiUrl}/doctor/doctor/get-by-slug`,
    ratings: `${apiUrl}/doctor/appointment-rating/list-by-doctor`,

    specialization: {
      getList: `${apiUrl}/doctor/specialization/get-list`,
      getById: `${apiUrl}/doctor/specialization`,
      all: `${apiUrl}/doctor/specialization/all`,
    },

    drService: {
      getList: `${apiUrl}/doctor/dr-service/get-list-show`,
      getById: `${apiUrl}/doctor/dr-service/get-by-id`,
    },

    timeTable: {
      getAllByDoctorCodeAndDate: `${apiUrl}/doctor/time-table/get-all-by-doctor-code-and-date`,
    },

    appointment: {
      create: `${apiUrl}/doctor/appointment/`,
      getMyAppointment: `${apiUrl}/doctor/appointment/my-appointment`,
      getById: `${apiUrl}/doctor/appointment`,
      getByKey: `${apiUrl}/doctor/appointment/get-by-key`,
      setCancelled: `${apiUrl}/doctor/appointment/set-cancelled`,
      rating: `${apiUrl}/doctor/appointment-rating/`,
      ratingByAppointment: `${apiUrl}/doctor/appointment-rating/by-appointment`,
      createFromPackage: `${apiUrl}/doctor/appointment/create-from-package/`,
      // The trailing slash is part of the path the apps call.
      calculateFee: `${apiUrl}/doctor/appointment/calculate-fee/`,
      checkExisted: `${apiUrl}/doctor/appointment/check-existed`,
      uploadAttachments: `${apiUrl}/doctor/appointment/upload-appointment-attachments`,
      deleteAttachment: `${apiUrl}/doctor/appointment/delete-appointment-attachment`,
    },

    symptom: {
      getList: `${apiUrl}/doctor/symptom-setting/get-list`,
    },
  },

  utils: {
    administrative: {
      getAllProvince: `${apiUrl}/utils/administrative/all-provinces`,
      getAllDistrictByProvinceCode: `${apiUrl}/utils/administrative/all-district-by-province-code`,
      getAllWardByProvinceCode: `${apiUrl}/utils/administrative/all-ward-by-province-code`,
    },

    promotion: {
      listPublic: `${apiUrl}/utils/promotion/list-public`,
      listPublicOnline: `${apiUrl}/utils/promotion/list-public-online`,
      apply: `${apiUrl}/utils/promotion/apply`,
      getByType: `${apiUrl}/utils/promotion/get-by-type`,
    },

    siteSpecialPackage: {
      getAllForApp: `${apiUrl}/utils/site-special-package/all-for-app`,
      getOne: `${apiUrl}/utils/site-special-package/get-by-site-code-and-package-code`,
      getBySlug: `${apiUrl}/utils/site-special-package/get-by-slug`,
    },

    specialCategory: {
      getListShow: `${apiUrl}/utils/special-category/list`,
    },

    interviewSetting: {
      groupByCode: `${apiUrl}/utils/interview/setting/group/get-by-code`,
      questionByCode: `${apiUrl}/utils/interview/setting/question/get-by-code`,
    },

    ratingComment: {
      getList: `${apiUrl}/utils/rating-comment/list-rating-comment`,
    },

    common: {
      getList: `${apiUrl}/utils/common/list`,
    },

    banner: {
      list: `${apiUrl}/utils/banner/list`,
      addView: `${apiUrl}/utils/banner/add-view`,
    },

    home: {
      listForWeb: `${apiUrl}/utils/home/list-for-web`,
    },

    allPageSearch: {
      getTopKeyWords: `${apiUrl}/utils/all-page-search/get-top-keywords`,
      search: `${apiUrl}/utils/all-page-search/search`,
    },

    collaboration: {
      getAll: `${apiUrl}/utils/collaboration/all`,
      register: `${apiUrl}/utils/collaboration/register`,
      update: `${apiUrl}/utils/collaboration/update`,
      testCaptcha: `${apiUrl}/utils/collaboration/test-captcha`,
    },
  },

  conferencing: {
    stringee: {
      getToken: `${apiUrl}/conferencing/stringee/get-token`,
    },
  },

  wp: {
    categories: {
      getCategories: `${wpApiUrl}/wp-json/wp/v2/categories`,
    },
    posts: {
      getPosts: `${wpApiUrl}/wp-json/wp/v2/posts`,
    },
    pages: {
      getPages: `${wpApiUrl}/wp-json/wp/v2/pages`,
    },
  },
};
